import React from 'react';
import CreatableInputField from '../../../components/CreatableInputField';
import SearchField from '../../../components/Input/SearchField';
import TextFieldLabel from '../../../components/Input/TextFieldLabel';

const SelectDetailField = (props) => {
	const { placeholder, label, value, editMode, onChange, autoFocus, disabled, options, creatable, noPlaceholder, invalid, width, minWidth, customWidth, linkTo } = props;
	return (
		<div className="detail-field-wrapper">
			{editMode ? (
				<React.Fragment>
					<TextFieldLabel>{label}</TextFieldLabel>
					{creatable ? (
						<CreatableInputField
							onInputChange={onChange}
							autoFocus={autoFocus}
							placeholder={noPlaceholder ? null : placeholder || label}
							value={value}
							onChange={onChange}
							options={options}
							className={`transition-fade-up-slow ${invalid ? "invalid-select-field" : ""}`}

						/>
					) : (
						<SearchField
							disabled={disabled}
							autoFocus={autoFocus}
							placeholder={noPlaceholder ? null : placeholder || label}
							value={value}
							options={options}
							onChange={onChange}
							classNames={`transition-fade-up-slow ${invalid ? "invalid-select-field" : ""}`}
							width={width}
							minWidth={minWidth}
							customWidth={customWidth}
						/>
					)}
				</React.Fragment>
			) : (
				<React.Fragment>
					<label className="colour-text-label-grey transition-fade-up">{label}</label>
					{linkTo
						? <a target={linkTo.target} href={linkTo.href} className={linkTo.className}>
							<p className="mt-s transition-fade-up-slow" style={{ wordBreak: "break-all" }}>
								{value?.label || value || "-"}
							</p>
						</a>
						: <p className="mt-s transition-fade-up-slow" style={{ wordBreak: "break-all" }}>
							{value?.label || value || "-"}
						</p>
					}
				</React.Fragment>
			)}
		</div>
	);
}

export default SelectDetailField;